import axios from "../shared/axios";
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as events from './events';

export function getItqQuote(itqquotationid) {
  return axios.get(`/api/InstructionToQuoteQuotation/GetItqQuotation?itqquotationid=${itqquotationid}`);
}

export function createItqQuote(data) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/InstructionToQuoteQuotation/Create`, data)
      .then((result) => {
        events.onNotification_CREATED();
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}

export function updateItqQuote(data) {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/InstructionToQuoteQuotation/Update`, data)
      .then((result) => {
        switch (data.actioncode) {
          case 'QUOTE_SAVE_DRAFT':
            events.onNotification_DRAFT_SAVED();
            break;
          case 'QUOTE_COMMUNICATE':
            events.onNotification_COMMUNICATED();
            break;
          case 'QUOTE_REPLY_DRAFT':
            events.onNotification_REPLY_DRAFT_SAVED();
            break;
          case 'QUOTE_REPLY_SEND':
            events.onNotification_REPLY_SENT();
            break;
          default:
            alert('Unknown action code!');
            break;
        }
        resolve(result);
      })
      .catch((error) => reject(error));
  });
}

export function getItqQuotes(companyid, projectid, contractid, instructiontoquoteid, accessibleWfIds) {
  return axios.post(`/api/InstructionToQuoteQuotation/RegisterList`, { accessibleWfIds }, { params: { companyid, projectid, contractid, instructiontoquoteid } });
}


export function deleteInstructionToQuoteDraft(itqquotationid) {
  return new Promise((resolve, reject) => {
    axios.post(`/api/InstructionToQuoteQuotation/DeleteDraft?itqquotationid=${itqquotationid}`)
      .then(result => {
        events.onNotification_DELETED();
        resolve(result);
      })
      .catch(error => reject(error));
  })
}

export function importQuotations(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.post(`/api/InstructionToQuoteQuotation/Import`, data);
      events.onNotification_CREATED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function deleteQuotationDrafts(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.delete(`/api/InstructionToQuoteQuotation/BulkDeleteDraft`, { data: data });
      events.onNotification_DELETED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function communicateQuotationDrafts(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await axios.put(`/api/InstructionToQuoteQuotation/BulkCommunicate`, data);
      events.onNotification_COMMUNICATED();
      resolve(result);
    }
    catch (err) {
      reject(err)
    }
  });
}

export function getAcceptedQuotation(instructiontoquoteid) {
  return axios.get(`/api/InstructionToQuoteQuotation/GetAcceptedQuotation`, { params: { instructiontoquoteid } });
}